module.exports = "/next-static/_next/static/images/streamyardView-2cfc903e13ecdcadbb7326ccc47377b3.png";